import React, { Component } from 'react'

export default class GroupGridFilterCustomerItem extends Component {

    render() {
        return (
            <div className="filterItem" style={{marginTop: 4, marginBottom: 4, cursor: 'pointer',}} onClick={() => {
                this.props.onFilter(this.props.groupName);
            }}>
                <div style={{
                    fontSize: 14,
                    fontWeight: 'bold',
                    paddingLeft: 5,
                    display: 'inline'}}>
                    {this.props.groupName}
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/grids/GroupGridFilterCustomerItem.js